import axios from "axios";

const COUNTRYCODE_ENDPOINT = "/api/customizeaccess/countrycode/";
const MASTERDATA_ENDPOINT = "/api/customizeaccess/masterdata/";
const USERDATA_ENDPOINT = "/api/account/users/";
const USERACCESSDATA_ENDPOINT = "/api/customizeaccess/useraccessdetails/";
const APPROVE_USER_ENDPOINT = "/api/customizeaccess/approveuser/";
const ADMINREGISTER_ENDPOINT = "/api/account/adminregister/";
const DELETE_USER_ENDPOINT = "/api/account/deleteuser/";
const REJECTED_USER_ENDPOINT = "/api/customizeaccess/rejectuser/";

export default {
  countryCode() {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${COUNTRYCODE_ENDPOINT}`
    );
  },
  masterData() {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${MASTERDATA_ENDPOINT}`
    );
  },
  userData() {
    return axios.get(`${process.env.VUE_APP_CONTEXTPATH}${USERDATA_ENDPOINT}`);
  },
  modifyUserAccessData(data) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${USERACCESSDATA_ENDPOINT}${data.userId}/`,
      data
    );
  },
  editedUserAccessData(userId) {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${USERACCESSDATA_ENDPOINT}${userId}/`
    );
  },
  deleteUserAPI(userId) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${DELETE_USER_ENDPOINT}`,
      { user_id: userId }
    );
  },
  rejectedUserAPI(userId) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${REJECTED_USER_ENDPOINT}`,
      { user_id: userId }
    );
  },
  approvedUserById(userId) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${APPROVE_USER_ENDPOINT}`,
      { user_id: userId }
    );
  },
  registeradmin(data) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${ADMINREGISTER_ENDPOINT}`,
      data
    );
  },
};
